// extracted by mini-css-extract-plugin
export default {"wrap":"FormModal_wrap__fH4C4","active":"FormModal_active__sxAcW","close":"FormModal_close__VDFTW","body":"FormModal_body__wMY+8"};